const ScreenIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.25 17.75H20C21.52 17.75 22.75 16.52 22.75 15V5C22.75 3.48 21.52 2.25 20 2.25H4C2.48 2.25 1.25 3.48 1.25 5V15C1.25 16.52 2.48 17.75 4 17.75H10.75V19.5C10.75 19.91 10.41 20.25 10 20.25H8C7.59 20.25 7.25 20.59 7.25 21C7.25 21.41 7.59 21.75 8 21.75H16C16.41 21.75 16.75 21.41 16.75 21C16.75 20.59 16.41 20.25 16 20.25H14C13.59 20.25 13.25 19.91 13.25 19.5V17.75ZM12.5 16.25H20C20.69 16.25 21.25 15.69 21.25 15V5C21.25 4.31 20.69 3.75 20 3.75H4C3.31 3.75 2.75 4.31 2.75 5V15C2.75 15.69 3.31 16.25 4 16.25H11.5H12.5Z"
				fill={color}
			/>
		</svg>
	);
};

export default ScreenIcon;
